import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './867551be402ddd479d309b090ca9bad4014d3249648d4aff8080c85bf49e3a1f.cfe-internal.js';
import '../../icons/index.es.js';
import ErrorIcon from '../../icons/components/51a09358b0531753d2bb03b493f69c735f312313b1daa645e62e3f349f7dc080.cfe-internal.js';

var _excluded = ["children", "className"];
var ErrorText = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames(className, styles.caption, styles.errorText);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement(ErrorIcon, {
    size: "small",
    className: styles.errorIcon,
    "aria-hidden": "true"
  }), children);
});

export { ErrorText as default };
